import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AppComponent } from "src/app/app.component";
import { AuthService } from "src/app/services/auth/auth.service";
import { Webflow } from "src/app/utils/webflow";
import { environment } from "src/environments/environment";
import Swal from "sweetalert2";

declare interface RouteInfo {
  action: any;
  title: string;
  icon: string;
  class: string;
  roles?: any;
  isConnected?: string;
}

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.scss"],
})
export class SidebarComponent implements OnInit {
  ROUTES: RouteInfo[] = [
    {
      action: () => {
        Webflow.myAction(this.router,"dashboard",{});
      },
      title: "Tableau de bord",
      icon: "ni-tv-2 text-danger",
      class: "",
      roles: ["manager_studio", "artist"],
      isConnected: "",
    },
    {
      action: () => {
        Webflow.myAction(this.router,"mes-reservations",{});
      },
      title: "Mes réservations",
      icon: "ni-bullet-list-67 text-danger",
      class: "",
      roles: ["artist"],
      isConnected: "true",
    },
    {
      action: () => {
        Webflow.myAction(this.router,"studios",{});
      },
      title: "Mes studios",
      icon: "fa fa-music text-danger",
      class: "",
      roles: ["manager_studio"],
      isConnected: "true",
    },
    {
      action: () => {
        Webflow.myAction(this.router,"reservations",{});
      },
      title: "Réservations",
      icon: "ni-bullet-list-67 text-danger",
      class: "",
      roles: ["manager_studio"],
      isConnected: "true",
    },
    {
      action: () => {
        Webflow.myAction(this.router,"mon-planning",{});
      },
      title: "Mon planning",
      icon: "ni-calendar-grid-58 text-danger",
      class: "",
      roles: ["manager_studio"],
      isConnected: "true",
    },
    {
      action: () => {
        Webflow.myAction(this.router,"passculture-historiques",{});
      },
      title: "Passculture",
      icon: "fa fa-history text-danger",
      class: "",
      roles: ["manager_studio"],
      isConnected: "true",
    },
    /*
    {
      action: () => {
        Webflow.myAction(this.router,"mes-factures",{});
      },
      title: "Mes factures",
      icon: "ni-single-copy-04 text-danger",
      class: "",
      roles: ["artist"],
      isConnected: "true",
    },
    */
    {
      action: () => {
        Webflow.myAction(this.router,"login",{});
      },
      title: "Se connecter",
      icon: "ni-key-25 text-danger",
      class: "",
      isConnected: "false",
    },
    {
      action: () => {
        Webflow.myAction(this.router,"register",{});
      },
      title: "Inscription",
      icon: "ni-ruler-pencil text-danger",
      class: "",
      isConnected: "false",
    },
    {
      action: () => {
        Webflow.myAction(this.router,"user-profile",{});
      },
      title: "Mon profil",
      icon: "ni-single-02 text-danger",
      class: "",
      roles: ["manager_studio", "artist"],
      isConnected: "true",
    },
    {
      action: () => {
        Webflow.myAction(this.router,"contact",{});
      },
      title: "Contactez nous",
      icon: "ni-send text-danger",
      class: "",
      isConnected: "",
    },
    {
      action: () => {
        Webflow.setIFrameHeight();
        Swal.fire({
          title: "Quitter",
          text: "Êtes-vous sûr de vouloir vous déconnecter ?",
          icon: "info",
          showCancelButton: true,
          confirmButtonText: `OUI`,
          cancelButtonText: `NON`,
          cancelButtonColor: "black",
          confirmButtonColor: "#D63333",
          position: "top",
        }).then((result) => {
          if (result.isConfirmed) {
            this.logout();
          }
        });
      },
      title: "Se déconnecter",
      icon: "ni-user-run text-danger",
      class: "",
      isConnected: "true",
    },
  ];
  public menuItems: any[];
  public menuBottomItems: any[];
  public isCollapsed = true;
  public currentUser: any;

  avatar: any;

  is_connected: boolean = false;
  fullName: string = "";
  title_btn_switch: string = "";

  switch_account: string = "";

  constructor(
    private router: Router,
    private authService: AuthService,
    private appComponent: AppComponent
  ) {}

  ngOnInit() {
    // Subscribe to current user data
    this.authService.currentUser.subscribe((user) => {
      this.currentUser = user;

      this.is_connected = user != null;

      this.avatar = this.is_connected ? user.profile.thumbnail : this.avatar;
      this.fullName = this.is_connected ? user.profile.full_name : "";

      this.switch_account = this.is_connected ? user.switch_account : "";
      this.title_btn_switch =
        this.switch_account == "manager_studio"
          ? "PASSER EN MODE ARTISTE"
          : "PASSER EN MODE GERANT";

      // Filter menu items based on the user's role
      this.menuItems = !!this.currentUser
        ? this.ROUTES.filter(
            (menuItem) =>
              (menuItem.isConnected != "false" &&
                (!menuItem.roles ||
                  (this.currentUser &&
                    menuItem.roles.includes(
                      this.currentUser.switch_account
                    )))) ||
              menuItem.isConnected == ""
          )
        : this.ROUTES.filter(
            (menuItem) =>
              (!menuItem.roles && menuItem.isConnected == "false") ||
              menuItem.isConnected == ""
          );
    });

    this.router.events.subscribe(() => {
      this.isCollapsed = true;
    });
  }

  logout() {
    this.authService.logout();
  }

  btn_switch_role() {
    if (this.currentUser != null && this.currentUser.role == "manager_studio") {
      this.appComponent.cutom_loading = true;
      this.currentUser.switch_account =
        this.currentUser.switch_account == "manager_studio"
          ? "artist"
          : "manager_studio";
      this.title_btn_switch =
        this.currentUser.switch_account == "manager_studio"
          ? "PASSER EN MODE ARTISTE"
          : "PASSER EN MODE GERANT";
      localStorage.setItem("studiomapUser", JSON.stringify(this.currentUser));
      this.authService.callCurrentUserSubject(this.currentUser);
      setTimeout(() => {
        Webflow.myAction(this.router,"dashboard",{});
        this.appComponent.cutom_loading = false;
      }, 1000);
    }
  }
}
